export class NavigationHistory {
	public idServicio: string;
	public codAsistente: string;
	public idMenu: string;
	public idFormAsociado: string;
}